import { Component, AfterViewInit, ViewContainerRef, NgZone, ChangeDetectorRef } from '@angular/core';
import { Title, DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import {
  TdLoadingService, TdMediaService, TdDialogService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
} from '@covalent/core';

import { Documento } from '../../../models/';
import { DocumentosService, LoginService } from '../../../services/';
import { DocumentosDetalleComponent } from './detalledocumentos/detalledocumentos.component';
import { DetalleJustificantesComponent } from './detallejustificantes/detallejustificantes.component';

@Component({
  selector: 'qs-documentos',
  templateUrl: './documentos.component.html',
  styleUrls: ['./documentos.component.scss'],
  viewProviders: [DocumentosService],
})

export class DocumentosComponent implements AfterViewInit {

  private documentos: any[];
  private documento: any;

  private visibleJ: boolean = true;
  private visibleI: boolean = true;
  private visibleC: boolean = true;

  private showJustificantes: boolean;
  private showCuidados: boolean;
  private showInformes: boolean;

  private documentosJustificantes: any[];
  private documentosInformes: any[];
  private documentosCuidados: any[];

  private idPaciente: string;
  private agenda: string;
  private centro: string;
  private dni: string;

  private columnsAll: ITdDataTableColumn[] = [
    { name: 'id', label: 'ID', tooltip: 'ID', sortable: true },
    { name: 'fecha', label: 'Fecha inicio', tooltip: 'Fecha inicio', sortable: true },
    { name: 'descripcion', label: 'Nombre', sortable: true },
    { name: 'hora', label: 'HORA', sortable: false, hidden: true },
    { name: 'nomcen', label: 'nomcen', sortable: false, hidden: true },
    { name: 'fecvisita', label: 'fecvisita', sortable: false, hidden: true },
    { name: 'horvisita', label: 'horvisita', sortable: false, hidden: true },
  ];

  private columns: ITdDataTableColumn[] = this.columnsAll;
  // Datos
  private filteredData: any[] = [];
  private filteredDataTotal: number;

  // Propiedades
  private clickable: boolean = true;
  private selectable: boolean = false;
  private sortable: boolean = true;
  private sortBy: string = 'fecha';
  private sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  private searchTerm: string = '';

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _documentosService: DocumentosService,
    private _loginService: LoginService,
    private _dataTableService: TdDataTableService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    public media: TdMediaService, ) { }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this._titleService.setTitle('Documentos');
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this.agenda = this._loginService.agenda;
    this.centro = this._loginService.profesional.TipoMedico.tipoMedico[0].Centro;
    this.dni = this._loginService.profesional.Dni;
    this._loadingService.register('documentos.load');
    this._documentosService.obtenerInformesTodos(this.idPaciente, this.agenda, this.centro, this.dni).subscribe((res: any) => {
      this.documentosCuidados = res.resultados.informesCuidados || [] ;
      this.documentosJustificantes = res.resultados.informesJustificantes || [] ;
      this.documentosInformes = res.resultados.informesClinicos || [] ;

      this.showCuidados = true;
      this.showInformes = true;
      this.showJustificantes = true;
      let newData: any[] = [];
      newData.push.apply(newData, this.documentosCuidados);
      newData.push.apply(newData, this.documentosJustificantes);
      newData.push.apply(newData, this.documentosInformes);

      this.filteredData = newData;
      this.filteredDataTotal = newData.length;
      this._loadingService.resolve('documentos.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje(error.message, 'OK', 6000);
      this._loadingService.resolve('documentos.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  downloadFile(file: string): any {

    let byteCharacters: string = atob(file);
    let byteArrays: any[] = [];
    let byteArray: Uint8Array;
    let sliceSize: number = 512;
    let newWindow: Window = window;
    let blob: Blob;
    let url: string = '';
    let slice: string = '';
    let byteNumbers: any[];

    for (let offset: number = 0; offset < byteCharacters.length; offset += sliceSize) {
      slice = byteCharacters.slice(offset, offset + sliceSize);
      byteNumbers = new Array(slice.length);
      for (let i: number = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    blob = new Blob(byteArrays, { type: 'application/pdf' });
    url = window.URL.createObjectURL(blob);
    return url;
  }

  // filterJustificantes(){
  //   this.aplicarFiltro();
  // }

  // filterInformes(){
  //   this.aplicarFiltro();
  // }

  // filterCuidados(){
  //   this.aplicarFiltro();
  // }

  aplicarFiltro(tipoDoc: string): void {
    let newData: any[] = [];

    switch (tipoDoc) {
      case 'J':
        this.visibleJ = !this.visibleJ;
        break;
      case 'C':
        this.visibleC = !this.visibleC;
        break;
      case 'I':
        this.visibleI = !this.visibleI;
        break;
        default:
    }

    if (this.visibleJ) {
      newData.push.apply(newData, this.documentosJustificantes);
    }
    if (this.visibleC) {
      newData.push.apply(newData, this.documentosCuidados);
    }
    if (this.visibleI) {
      newData.push.apply(newData, this.documentosInformes);
    }

    this.filteredData = newData;
    this.filteredDataTotal = newData.length;
  }

  openDetail(documento: any): void {
    if (documento.descripcion === 'JUSTIFICANTE') {
      let dialogRef: any = this._dialogService.open(DetalleJustificantesComponent, {
        data: documento,
        width: '75%',
        role: 'dialog',
      });
      dialogRef.componentInstance.documento = documento;
      dialogRef.componentInstance.dniProfesional = this._loginService.profesional.Dni;
      dialogRef.componentInstance.dniPaciente = this._loginService.consulta.dni;
      dialogRef.componentInstance.nombrePaciente = this._loginService.consulta.nombre + ' ' + this._loginService.consulta.apellidos;
      dialogRef.componentInstance.nombreProfesional = this._loginService.profesional.Personal.Nombre
        + ' ' + this._loginService.profesional.Personal.Apellido1
        + ' ' + this._loginService.profesional.Personal.Apellido2;
    } else {
    this._documentosService.obtenerInformePdf(documento.id).subscribe((res: any) => {
      let document: any = {
        url: this.downloadFile(res.respuesta),
        titulo: documento.descripcion,
        fecha: documento.fecha,
      };
      this._loginService.transient = document;
      this._router.navigate(['documentosdetalle'], { relativeTo: this._route });
    }, (error: Error) => {
      this._loginService.mostrarMensaje(error.message, 'OK', 6000);
    });
  }

  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  filter(): void {

    let newData: any[] = [];
    if (this.showCuidados) {
      newData.push.apply(newData, this.documentosCuidados);
    }

    if (this.showInformes) {
      newData.push.apply(newData, this.documentosInformes);
    }

    if (this.showJustificantes) {
      newData.push.apply(newData, this.documentosJustificantes);
    }
    this.filteredData = newData;
    this.filteredDataTotal = newData.length;

    // let newData: any[] = this.documentos;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredDataTotal = newData.length;
    newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    this.filteredData = newData;
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/documentos/documentos.component.ts